import { render, staticRenderFns } from "./ProjectsArchiveShowPage.vue?vue&type=template&id=bce96f6c&scoped=true&"
import script from "./ProjectsArchiveShowPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsArchiveShowPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsArchiveShowPage.vue?vue&type=style&index=0&id=bce96f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce96f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bce96f6c')) {
      api.createRecord('bce96f6c', component.options)
    } else {
      api.reload('bce96f6c', component.options)
    }
    module.hot.accept("./ProjectsArchiveShowPage.vue?vue&type=template&id=bce96f6c&scoped=true&", function () {
      api.rerender('bce96f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsArchiveShowPage.vue"
export default component.exports